import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconBorderLeftRight$1 = /*@__PURE__*/ proxyCustomElement(class WppIconBorderLeftRight extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-border-left-right", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { d: "M15.4998 6.00191C15.4998 5.36799 15.1065 4.82592 14.5507 4.60631C14.5192 4.59759 14.4879 4.58671 14.4571 4.5736C14.0758 4.41179 13.898 3.97157 14.0598 3.59036C14.2216 3.20919 14.6617 3.03133 15.0429 3.19305V3.18825C16.1855 3.61202 16.9998 4.71188 16.9998 6.00191V14.0019C16.9998 15.2919 16.1855 16.3918 15.0429 16.8156V16.8124C14.6617 16.9742 14.2215 16.7963 14.0597 16.4151C13.8979 16.0339 14.0758 15.5937 14.457 15.4319L14.4672 15.4276C14.4893 15.4187 14.5115 15.4108 14.5338 15.4041C15.0985 15.1889 15.4998 14.6422 15.4998 14.0019V6.00191ZM8.75098 3.00195C8.33676 3.00195 8.00098 3.33774 8.00098 3.75195C8.00098 4.16617 8.33676 4.50195 8.75098 4.50195L11.251 4.50195C11.6652 4.50195 12.001 4.16617 12.001 3.75195C12.001 3.33774 11.6652 3.00195 11.251 3.00195L8.75098 3.00195ZM8.75098 15.502C8.33676 15.502 8.00098 15.8377 8.00098 16.252C8.00098 16.6662 8.33676 17.002 8.75098 17.002H11.251C11.6652 17.002 12.001 16.6662 12.001 16.252C12.001 15.8377 11.6652 15.502 11.251 15.502H8.75098ZM5.44908 4.60631C4.89323 4.82592 4.5 5.36799 4.5 6.00191L4.5 14.0019C4.5 14.6422 4.90123 15.1889 5.46599 15.4041C5.4883 15.4108 5.5105 15.4187 5.53251 15.4276L5.54283 15.431C5.92404 15.5928 6.10186 16.0339 5.94005 16.4151C5.77823 16.7963 5.33805 16.9742 4.95684 16.8124V16.8156C3.81425 16.3918 3 15.2919 3 14.0019L3 6.00191C3 4.71188 3.81425 3.61202 4.95684 3.18825V3.19305C5.33803 3.03133 5.77816 3.20919 5.93996 3.59036C6.10177 3.97157 5.92392 4.41179 5.5427 4.5736C5.51182 4.58671 5.48055 4.59759 5.44908 4.60631Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-border-left-right-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-border-left-right", "wpp-icon-border-left-right-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-border-left-right-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-border-left-right-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconBorderLeftRight$1);
      }
      break;
  } });
}

const WppIconBorderLeftRight = WppIconBorderLeftRight$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconBorderLeftRight, defineCustomElement };
